<div (scroll)="onScroll($event)" id = "Individual-disp" class="parent" *ngIf="(data?.length && !isHandset) else mobileTemplate">

  <div class="grid">
    <span class="columnHeader" *ngFor="let t of columns">
      {{ t }}
    </span>
  </div>
  <div class="grid gridRow" *ngFor="let k of data" [ngClass]="{'highlight': checkIfTextContainsSearchTerm(k), 'selectedBackgroundRow': k.uid === selectedItem?.uid}" [ngStyle]="{'cursor': 'pointer' }"  (click)="onRowClick(k)" (dblclick)="editable ? editRow.emit(k) : false">
    <span><i class="icon fa-lg fal fa-pencil" style="color: green;" (click)="editRow.emit(k)" title="Edit this individual" *ngIf="editable"></i> {{ k.firstName }}
    {{ k.lastName }}</span>
    <span class="pertinent">{{ k.rank?.rankCategory?.rankCategory }} &mdash; {{ k.rank?.rankName }}</span>
    <span *ngIf="typeOfImageId !== ImageTypes['Letters & Diaries']">{{ k.currentRankInPhoto ? 'Yes' : 'No' }}</span>
    <span *ngIf="typeOfImageId === ImageTypes['Letters & Diaries']">{{ k.author ? 'Yes' : 'No' }}</span>
    <span class="pertinent2">{{ k.regimentNo?.regimentNo !== undefined ? writeOrdinalSuffix( k.regimentNo?.regimentNo) : '' }}</span>
    <span class="pertinent2">{{ k.state?.abbreviation }}</span>
    <span class="pertinent2">{{ k.branch?.branchName }}</span>
    <span>{{ k.companyLetters }}</span>
    <!-- ellipsis notes modal disabled 5/21/24, switched to new modal 
    <span class="ellipsis" [matTooltip]="(k.notes?.length > 12) ? 'Click to view more.' : ''" [ngStyle]="{'cursor': (k.notes?.length > 12) ? 'pointer' : 'default'}" (click)="seeMoreText(k)"><span [ngStyle]="{'cursor': (k.notes?.length > 12) ? 'pointer' : 'default'}">{{ k.notes }}</span></span>-->
    <span class="ellipsis" [matTooltip]="(k.notes?.length > 12) ? 'Click to view more.' : ''" [ngStyle]="{'cursor': (k.notes?.length > 12) ? 'pointer' : 'default'}" ><span [ngStyle]="{'cursor': (k.notes?.length > 12) ? 'pointer' : 'default'}">{{ k.notes }}</span></span>
  </div>
</div>
<div class="recordCount" *ngIf="data?.length; else noData">
    {{ totalRecords }} individual(s) record(s).
</div>

<ng-template #moreInfo>
   <div class="container">
    <!-- Name Row Start -->
    <div class="row col-md-12">
        <h5>Name</h5>
    </div>

    <div class="row">
      <div class="col-md-12 bolder">
        <h3>{{ selectedItem.firstName }}&nbsp;{{ selectedItem.lastName }}</h3>
      </div>
    </div>
    <!-- Name Row End -->

    <!-- Rank Row Start -->
    <div class="row col-md-12 mt-2 ">
      <div class="row col-md-12">
        <h5>Rank</h5>
      </div>
      <div class="row col-md-12 bolder">
        <h3>{{selectedItem.rank?.rankDisplay}}</h3>
      </div>
    </div>
    <!-- Rank Row End -->

    <!-- Currnent Rank Row Start -->
    <div class="row col-md-12 mt-2">
      <h5>Current rank shown in photo?
      </h5>
      <h5 style="font-weight: bold;">&nbsp;{{isRankShown()}}</h5>
    </div>
    <!-- Currnent Rank Row end -->

    <!-- Unit Table Start -->
    <div class="row col-md-12 mt-2">  
      <div class="row col-md-12 ">
        <h5>Unit</h5>
      </div>
      <div class="row col-md-2">
        <div class="row col-md-12">
          <h5>Army</h5>
        </div>
        <div class="row col-md-12 bolder">
          <h4>{{ selectedItem.army === 1 ? 'US' : 'CS' }}</h4>
        </div>
      </div>
      <div class="row col-md-2">
        <div class="row col-md-12">
          <h5>Corps</h5>
        </div>
        <div class="row col-md-12 bolder">
          <h4>{{selectedItem.corps !== null ? writeOrdinalSuffix(selectedItem.corps) : "-"}}</h4>
        </div>
      </div>
      <div class="row col-md-2">
        <div class="row col-md-12">
          <h5>Regiment#</h5>
        </div>
        <div class="row col-md-12 bolder">
          <h4>{{selectedItem.regimentNo !== null ? selectedItem.regimentNo.regimentNo !== null ? writeOrdinalSuffix(selectedItem.regimentNo?.regimentNo) : "-" : "-"}}</h4>
        </div>
      </div>
      <div class="row col-md-2">
        <div class="row col-md-12">
          <h5>State</h5>
        </div>
        <div class="row col-md-12 bolder">
          <h4>{{ selectedItem.state !== null ? selectedItem.state.abbreviation !== null ? selectedItem.state?.abbreviation : "-" : "-"}}</h4>
        </div>
      </div>
      <div class="row col-md-2">
        <div class="row col-md-12">
          <h5>Branch</h5>
        </div>
        <div class="row col-md-12 bolder">
          <h4>{{ selectedItem.branch !== null ? selectedItem.branch.branchName !== null ? selectedItem.branch?.branchName : "-" : "-"}}</h4>
        </div>
      </div>
      <div class="row col-md-2">
        <div class="row col-md-12">
          <h5>Companies</h5>
        </div>
        <div class="row col-md-12 bolder">
          <h4>{{ selectedItem.companyLetters?.length !== 0 ? selectedItem.companyLetters : "-"}}</h4>
        </div>
      </div>
    </div>
    <!-- Unit Table End -->

    <!-- Notes Start -->
    <div class="row col-md-12 mt-2">
      <h5 style="width: 100%;">Notes       
        <textarea [disabled]="true" class="form-control" rows="7"[(ngModel)]="selectedItem.notes"
        style="resize: both;font-size: 18px;">
        </textarea>
      </h5>
    </div>
    <!-- Notes End -->
   </div>
 </ng-template>

<ng-template #noData>
  <div class="recordCount">We don't have any Individuals for this record.</div>
</ng-template>
<ng-template #notesModal>
  <p [innerHTML]="notesToEmbolden | embolden : searchText"></p>
</ng-template>


<ng-template #mobileTemplate>
  <div id="Individual-disp" *ngIf="data?.length" class="parent mobile">
    <table class="individual-table">
      <thead>
        <tr>
          <th *ngFor="let t of columns">{{ t }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let k of data" [ngClass]="{'highlight': checkIfTextContainsSearchTerm(k), 'selectedBackgroundRow': k.uid === selectedItem?.uid}" [ngStyle]="{'cursor': 'pointer' }"  (click)="onRowClick(k)" (dblclick)="editable ? editRow.emit(k) : false">
          <td>
            <i class="icon fa-lg fal fa-pencil" style="color: green;" (click)="editRow.emit(k)" title="Edit this individual" *ngIf="editable"></i> 
            {{ k.firstName }} {{ k.lastName }}
          </td>
          <td class="pertinent">{{ k.rank?.rankCategory?.rankCategory }} &mdash; {{ k.rank?.rankName }}</td>
          <td *ngIf="typeOfImageId !== ImageTypes['Letters & Diaries']">{{ k.currentRankInPhoto ? 'Yes' : 'No' }}</td>
          <td *ngIf="typeOfImageId === ImageTypes['Letters & Diaries']">{{ k.author ? 'Yes' : 'No' }}</td>
          <td class="pertinent2">{{ k.regimentNo?.regimentNo !== undefined ? writeOrdinalSuffix(k.regimentNo?.regimentNo) : '' }}</td>
          <!-- <td class="pertinent2">{{ k.state?.abbreviation }}</td>
          <td class="pertinent2">{{ k.branch?.branchName }}</td>
          <td>{{ k.companyLetters }}</td>
          <td class="ellipsis" [matTooltip]="(k.notes?.length > 12) ? 'Click to view more.' : ''" [ngStyle]="{'cursor': (k.notes?.length > 12) ? 'pointer' : 'default'}">
            <span [ngStyle]="{'cursor': (k.notes?.length > 12) ? 'pointer' : 'default'}">{{ k.notes }}</span>
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>

</ng-template>